export const SET_ONGOING_SERVER_ACTIVITY = "TOGGLE_ONGOING_SERVER_ACTIVITY";
